import { Link } from 'react-router-dom'
import Header from '../components/Header'

const NotFound = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <div className="flex min-h-[calc(100vh-3rem)] items-center justify-center px-4">
        <div className="text-center">
          <p className="text-sm font-semibold text-brand-600">404</p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight text-neutral-900">Page not found</h1>
          <p className="mt-2 text-sm text-neutral-500">The page you're looking for doesn't exist.</p>
          <Link
            to="/"
            className="mt-6 inline-block rounded-lg bg-brand-600 px-5 py-2.5 text-sm font-medium text-white no-underline hover:bg-brand-700"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
